<div class="l-navbar" [ngClass]="{'show': sidebarService.showSidebar}"
id="nav-bar">
  <nav class="nav">
    <div>
      <menu class="nav_list" (mouseout)="closeSidebar()" (mouseover)="openSidebar()">
        <a *ngFor="let link of sidebarLinks" (click)="navigate(link.link)" class="nav_link"
          [ngClass]="{'active': isCurrentPage(link.link)}">
          <i [class]="(link.icon ? link.icon : 'bx bx-grid-alt') + ' bx nav_icon'"></i> <span class="nav_name">{{ link.label }}</span>
        </a>
      </menu>
      <!--<menu class="nav_list" (mouseout)="closeSidebar()" (mouseover)="openSidebar()">
        <a [routerLink]="[links.courses]" class="nav_link" [ngClass]="{'active':isCurrentPage('/course')}">
          <i class='bx bx-grid-alt nav_icon'></i> <span class="nav_name">Mis cursos</span>
        </a> 
        <a [routerLink]="[links.lessons]" class="nav_link" [ngClass]="{'active':isCurrentPage('/lesson')}">
          <i class='bx bx-grid-alt nav_icon'></i> <span class="nav_name">Mis lecciones</span>
        </a>
        <a [routerLink]="[links.students]" class="nav_link" [ngClass]="{'active':isCurrentPage(links.students)}">
          <i class='bx bx-group nav_icon'></i> <span class="nav_name">Alumnos</span>
        </a>
        <a [routerLink]="[links.files]" class="nav_link" [ngClass]="{'active':isCurrentPage(links.files)}">
          <i class='bx bx-folder nav_icon'></i> <span class="nav_name">Ficheros</span>
        </a> 
        <a [routerLink]="[links.metrics]" class="nav_link" [ngClass]="{'active':isCurrentPage('/metrics')}">
          <i class='bx bx-bar-chart-alt-2 nav_icon'></i> <span class="nav_name">Métricas</span>
        </a>
        <a [routerLink]="[links.dashboard]" class="nav_link" [ngClass]="{'active':isCurrentPage('/dashboard')}">
          <i class='bx bx-bar-chart-alt-2 nav_icon'></i> <span class="nav_name">Dashboard</span>
        </a>
      </menu>-->
    </div>
  </nav>
</div>
